module.exports = fox._r("images/bg/head_text_bg.png", __webpack_public_path__ + "images/bg/head_text_bg.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/bg/head_text_bg.png
// module id = 1013
// module chunks = 4